// extracted by mini-css-extract-plugin
export default {"button":"DateRangePicker_button__bYb3c","placeholder":"DateRangePicker_placeholder__cckBU"};